import api from "@/utils/axios";

export const fetchAdminEmails = (params = {}) =>
  api.get("/v1/admin/emails", { params }).then((res) => res.data);

export const fetchAdminEmail = (id) =>
  api.get(`/v1/admin/emails/${id}`).then((res) => res.data);

export const sendAdminEmail = (payload) =>
  api.post("/v1/admin/emails/send", payload).then((res) => res.data);

export const markAdminEmailRead = (id) =>
  api.patch(`/v1/admin/emails/${id}/read`).then((res) => res.data);

export const deleteAdminEmail = (id) =>
  api.delete(`/v1/admin/emails/${id}`).then((res) => res.data);
